// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1aZQs","footer":"ModalCreateQualiphyProcedure_footer___VuCl","additionData":"ModalCreateQualiphyProcedure_additionData__2korv"};